import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/states/app.state';
import * as fromUserActions from '../../store/actions/user.action'

@Injectable({
  providedIn: 'root'
})
export class AuthSessionInterceptor implements HttpInterceptor {
  constructor(
    private store: Store<AppState>
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = req.clone({
      withCredentials: true
    });

    return next.handle(authReq)
      .pipe(
        catchError(error => {
          // only 401 must cause a logout. 403 means, the user is known, but they have no access to the resource -> don't log them out!
          if (error instanceof HttpErrorResponse && (error.status === 401) && !authReq.url.includes('login')) {
            // Redirect to login
            return this.handleError(authReq, next);
          }
          return throwError(error);
        })
      );
  }

  private handleError(request: HttpRequest<any>, next: HttpHandler) {
    this.store.dispatch(fromUserActions.logoutUser());
    return next.handle(request);
  }
}
